import {
  Component,
  Event,
  EventEmitter,
  h,
  Host,
  Method,
  Prop,
  State,
} from "@stencil/core";
import { AddToCartEvent } from "@apis/model/add-to-cart-event";
import { Cart } from "@apis/model/mini-cart";
import {
  BcpDuplicationEntryModalProps,
  BcpDuplicationEntryModalState,
  PreventMergeEntry,
} from "./bcp-duplication-entry-modal-model";

@Component({
  tag: "bcp-duplication-entry-modal",
  styleUrl: "bcp-duplication-entry-modal.scss",
})
export class BcpDuplicationEntryModal {
  @Prop() headerLabel: BcpDuplicationEntryModalProps["headerLabel"] =
    "Add to Cart";

  @Prop() bodyLabel: BcpDuplicationEntryModalProps["bodyLabel"] =
    "Product already present in cart";

  @Prop() increaseLabel: BcpDuplicationEntryModalProps["increaseLabel"] =
    "Increase quantity";

  @Prop() newLineLabel: BcpDuplicationEntryModalProps["newLineLabel"] =
    "Add new line";

  @Prop() cancelLabel: BcpDuplicationEntryModalProps["cancelLabel"] = "Cancel";

  @Prop() addToWishlistUrl: BcpDuplicationEntryModalProps["addToWishlistUrl"];

  @Prop() productCode: BcpDuplicationEntryModalProps["productCode"];

  @Prop() quantity: BcpDuplicationEntryModalProps["quantity"] = 1;

  @State()
  selectWishlistDialogVisible: BcpDuplicationEntryModalState["selectWishlistDialogVisible"] =
    false;

  private cart: Cart = null;

  @Method()
  async openModel(cart: Cart): Promise<void> {
    this.cart = cart;
    await this.dialog.openDialog();
  }

  @Method()
  async closeModel(): Promise<void> {
    await this.dialog.closeDialog();
  }

  @Event() addedToSelectedCart: EventEmitter<AddToCartEvent>;

  private dialog: HTMLFDialogElement = null;

  private handleIncreaseButtonClick = (): void => {
    sessionStorage.setItem("preventEntriesMerge", PreventMergeEntry.PREVENT);
    this.addedToSelectedCart.emit({
      cart: this.cart,
      productCode: this.productCode,
    });
    this.dialog.closeDialog();
  };

  private handleMergeButtonClick = (): void => {
    sessionStorage.setItem("preventEntriesMerge", PreventMergeEntry.MERGE);
    this.addedToSelectedCart.emit({
      cart: this.cart,
      productCode: this.productCode,
    });
    this.dialog.closeDialog();
  };

  render() {
    return (
      <Host>
        <f-dialog
          ref={(el) => (this.dialog = el)}
          headerTitle={this.headerLabel}
          bodyTitle={this.bodyLabel}
          closeIcon={true}
          showDialog={this.selectWishlistDialogVisible}
          withTopBorder={true}
          data-test="duplication-entry-modal"
        >
          <div class="duplication-modal__action-buttons-container">
            <f-button
              onClick={this.handleMergeButtonClick}
              variant={"primary"}
              fullWidth={true}
              data-test="duplication-entry-modal-increase-quantity-button"
            >
              {this.increaseLabel}
            </f-button>
            <f-button
              onClick={this.handleIncreaseButtonClick}
              variant={"primary"}
              fullWidth={true}
              data-test="duplication-entry-modal-add-new-line-button"
            >
              {this.newLineLabel}
            </f-button>
            <f-button
              onClick={() => this.dialog.closeDialog()}
              variant={"secondary"}
              fullWidth={true}
              data-test="duplication-entry-modal-cancel-button"
            >
              {this.cancelLabel}
            </f-button>
          </div>
        </f-dialog>
      </Host>
    );
  }
}
